import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import { faQrcode } from '@fortawesome/free-solid-svg-icons/faQrcode';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AtiraEmptyWithAction } from '../../../components/AtiraEmptyWithAction';
import { Flex } from '../../../components/Flex';
import { Text } from '../../../components/Text';
import { PageMeta } from '../../../model/meta/PageMeta';
import { QRSliceSelectors } from '../../../redux/QR/qr.selector';
import { QRActions } from '../../../redux/QR/qr.slice';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { userSliceSelectors } from '../../../redux/user/user.selector';
import { DashboardWidget } from './DashboardWidget';

export const DashboardQRWidget: React.FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const loggedInUserId = useAppSelector(
    userSliceSelectors.selectLoggedInUserId,
  )!;

  const userQRs = useAppSelector(QRSliceSelectors.selectAllQRs);

  useEffect(() => {
    dispatch(
      QRActions.getUserQRs({ userId: loggedInUserId, meta: PageMeta.create() }),
    );
  }, [dispatch, loggedInUserId]);

  return (
    <DashboardWidget
      title={t('dashboard.widget.qr.title')}
      titleIcon={faQrcode}
      mainAction={{
        title: <Trans i18nKey={'dashboard.widget.qr.action'} />,
        icon: faPlusCircle,
        onClick: () =>
          navigate('/my-qrs', { state: { isNavigatedToCreate: true } }),
      }}
      moreActionLink="/my-qrs"
      showActions={Boolean(userQRs?.length)}
    >
      {userQRs?.length ? (
        <Flex padding="m">
          <Text>
            <Trans
              i18nKey={'dashboard.widget.qr.count'}
              values={{ count: userQRs?.length }}
              components={[<strong />]}
            />
          </Text>
        </Flex>
      ) : (
        <Flex padding="xl" justifyContent="center" height={'150px'}>
          <AtiraEmptyWithAction
            buttonTitle={t('dashboard.widget.qr.action')}
            description={t('dashboard.widget.qr.empty.title')}
            onClick={() =>
              navigate('/my-qrs', { state: { isNavigatedToCreate: true } })
            }
            buttonWidth="16rem"
          />
        </Flex>
      )}
    </DashboardWidget>
  );
};
